import { render, staticRenderFns } from "./main-drawer.vue?vue&type=template&id=a30113d6&scoped=true"
import script from "./main-drawer.vue?vue&type=script&lang=js"
export * from "./main-drawer.vue?vue&type=script&lang=js"
import style0 from "./main-drawer.vue?vue&type=style&index=0&id=a30113d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30113d6",
  null
  
)

export default component.exports